'use client'

import { useRouter } from 'next/navigation'

import { Button, Icon } from '@graftcode/design-system'

import styles from '@common/components/MobileMenu/MobileMenu.module.scss'
import { HomeNavItems } from '@common/components/MobileMenu/variants/AcademyMobileMenu/components/AcademyNavigation/HomeNavItems'
import { useExpandedCategories } from '@common/components/MobileMenu/variants/AcademyMobileMenu/hooks/useExpandedCategories'
import type { MobileNavigationState } from '@common/components/MobileMenu/variants/AcademyMobileMenu/hooks/useMobileNavigation'

import type { TutorialSection } from '@/lib/github/types'
import { ACADEMY_MOBILE_MENU_TEST_IDS } from '@/shared/docs-test-ids.const'

type GuestAcademyNavigationProps = {
  nav: MobileNavigationState
  tutorialSections: TutorialSection[]
  currentTutorialPath?: string
}

export function GuestAcademyNavigation({ nav, tutorialSections, currentTutorialPath }: GuestAcademyNavigationProps) {
  const router = useRouter()

  const handleSignIn = () => {
    router.push('/auth/login')
  }

  const { expandedCategories, toggleCategory } = useExpandedCategories({
    currentTutorialPath,
    isDocumentationPage: nav.isDocumentationPage,
    documentationCategoryTree: nav.documentationCategoryTree,
    quickStartCategoryTree: nav.quickStartCategoryTree,
  })

  return (
    <div data-testid={ACADEMY_MOBILE_MENU_TEST_IDS.root} className={styles.academyMainNavigation}>
      {nav.isSubpage && (
        <Button
          variant="ghost"
          size="l"
          fullWidth
          icon={Icon.ArrowLeftRegular}
          text="Back to Home"
          onClick={() => nav.handleNavigationClick('/')}
          className={styles.academyBackToHome}
        />
      )}

      <Button variant="primary" size="l" fullWidth text="Sign In" onClick={handleSignIn} />

      <HomeNavItems
        nav={nav}
        onNavigationClick={nav.handleNavigationClick}
        tutorialSections={tutorialSections}
        currentTutorialPath={currentTutorialPath}
        expandedCategories={expandedCategories}
        onToggleCategory={toggleCategory}
      />
    </div>
  )
}
